import NotificationsList from "./NotificationsList";
import NotificationBell from "./NotificationBell";
import { type NotificationProps } from "./DropdownNotification";
import { useRef, useState, useMemo } from "react";
import { useLocation } from "@remix-run/react";

interface NotificationGlobalState {
  icon: React.ReactNode;
  mobileStyle?: boolean;
  onAssestPage?: React.CSSProperties["left"];
}

interface Props extends NotificationGlobalState {
  notifications: NotificationProps[];
  portfolioId?: number;
  updateNotifications: (productId: string, insightId: string) => void;
}

const Notification = ({
  notifications,
  portfolioId,
  icon,
  mobileStyle,
  onAssestPage,
  updateNotifications,
}: Props) => {
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const numberOfNotifications = useMemo(() => {
    return notifications.reduce((sum, current) => {
      return sum + (current.shouldNotify ? 1 : 0);
    }, 0);
  }, [notifications]);

  if (location.pathname.startsWith("/planner")) {
    return <div className="relative h-7 w-7" />;
  }

  return (
    <div className="relative h-7 w-7" ref={containerRef}>
      <NotificationBell
        icon={icon}
        toggle={() => setIsDropdownOpen(!isDropdownOpen)}
        notificationCount={numberOfNotifications}
        notificationLength={notifications.length}
      />
      <NotificationsList
        onAssestPage={onAssestPage}
        mobileStyle={mobileStyle}
        isOpen={isDropdownOpen}
        notifications={notifications}
        closeDropdown={() => setIsDropdownOpen(false)}
        containerRef={containerRef.current}
        updateNotifications={updateNotifications}
        portfolioId={portfolioId}
      />
    </div>
  );
};
export default Notification;
